module.exports = __webpack_public_path__ + "static/fonts/Exo2-Regular.ttf";